export default {
//     'URL': 'http://localhost:8000',
    'URL': 'https://njackhackitout-tur1ng-production.up.railway.app',
}
